<div class="DownloadAppModal" appAmInactive='md'>
  <div class="DownloadAppModal-close">
    <img alt="" src="../../../../assets/images/close.svg" (click)="onClose()" />
  </div>
  <div class="DownloadAppModal-container text-center">
    <span class="fs-42px lh-52px fw-medium-x">
      App Aeroméxico
    </span>
    <div class="DownloadAppModal-storeImages">
      <div class="DownloadAppModal-appleStore">
        <qrcode [qrdata]="urlApple"
          [width]="200"
          [errorCorrectionLevel]="'M'"
          [cssClass]="'center'"
          [colorDark]="'#000000ff'"
          [colorLight]="'#ffffffff'"
          [elementType]="'canvas'"
        ></qrcode>
        <img alt="appleStore" class="DownloadAppModal-imageApple" src="../../../../assets/images/Apple_Store.svg" />
      </div>
      <div class="DownloadAppModal-separator">
      </div>
      <div class="DownloadAppModal-playStore">
        <qrcode [qrdata]="urlPlay"
          [width]="200"
          [errorCorrectionLevel]="'M'"
          [cssClass]="'center'"
          [colorDark]="'#000000ff'"
          [colorLight]="'#ffffffff'"
          [elementType]="'canvas'"
        ></qrcode>
        <img alt="playStore" class="DownloadAppModal-imagePlay" src="../../../../assets/images/Play_Store.svg" />
      </div>
    </div>
    <p class="fs-24px lh-34px fw-regular">
      {{ 'DownloadAppModal.description' | translate }}
    </p>
  </div>
</div>